import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-teal-500 to-teal-600 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-6">
              <img
                src="/assets/img/ed091f26a7fa.webp"
                alt="Pop Pro Tents"
                className="h-16 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-sm text-white/90 leading-relaxed mb-6">
              Pop Pro Tents designs and manufactures premium stretch tents and canopies for sale worldwide, and provides full-service event tent rentals across the USA — all from our Austin, Texas base.
            </p>
            <div className="flex gap-3">
              <a href="https://www.facebook.com/popprotents/" className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-lg flex items-center justify-center transition-colors">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://www.instagram.com/popprotents" className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-lg flex items-center justify-center transition-colors">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://www.linkedin.com/company/popprotents" className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-lg flex items-center justify-center transition-colors">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-white/90 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-white/90 hover:text-white transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-sm text-white/90 hover:text-white transition-colors">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/apply" className="text-sm text-white/90 hover:text-white transition-colors">
                  Join The Team
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-sm text-white/90 hover:text-white transition-colors">
                  Case Studies
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-sm text-white/90 hover:text-white transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/blog#faq" className="text-sm text-white/90 hover:text-white transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-white/90 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-white/90 hover:text-white transition-colors">
                  Inquire Now
                </Link>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-lg font-bold mb-6">Our Products</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/products/standard-stretch-tents" className="text-sm text-white/90 hover:text-white transition-colors">
                  Standard Stretch Tents
                </Link>
              </li>
              <li>
                <Link to="/products/custom-stretch-tents" className="text-sm text-white/90 hover:text-white transition-colors">
                  Custom Stretch Tents
                </Link>
              </li>
              <li>
                <Link to="/products/custom-printed-skins" className="text-sm text-white/90 hover:text-white transition-colors">
                  Custom Printed Skins
                </Link>
              </li>
              <li>
                <Link to="/products/bespoke-decor" className="text-sm text-white/90 hover:text-white transition-colors">
                  Bespoke Decor
                </Link>
              </li>
              <li>
                <Link to="/engineering-safety" className="text-sm text-white/90 hover:text-white transition-colors">
                  Engineering &amp; Safety
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6">Contact Info</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-lg mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-white/90">
                  Austin, Texas
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-lg flex-shrink-0"></i>
                <span className="text-sm text-white/90">+1 656-347-7380</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-mail-line text-lg flex-shrink-0"></i>
                <span className="text-sm text-white/90">info@popprotents.com</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-time-line text-lg flex-shrink-0"></i>
                <span className="text-sm text-white/90">Mon-Fri: 8:00 AM - 5:00 PM</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/90">
              © 2026 Pop Pro Tents®. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-sm text-white/90 hover:text-white transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-white/90 hover:text-white transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-sm text-white/90 hover:text-white transition-colors">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
